export const constantStyles = {
    outermostMargin: '0 24px',
    mainDarkGreen: '#011E04',
    saleRed: '#ff0000b8',
    mainFontFamily: 'Newsreader',
    mainBackgroundColor: '#fff',
    footerHeight: '103px',
    minPageHeight : 'calc(100vh - 103px)',
    mobileWidth: 768,
}
